export default function(){

    if( $('.js-menu-toggle').is(':hidden') ){
        $('.menu-item.image-menu').each(function(){
            $(this).children('.sub-menu').css('left', - $(this).offset().left);
        });
    }

    //position image menus to left of screen, simulate container width, only on desktop
    $('.menu-item.image-menu').on('hover', function(){
        if( $('.js-menu-toggle').is(':hidden') ){
            $(this).children('.sub-menu').css('left', - $(this).offset().left);
            $(this).children('.sub-menu').css('padding',
                '2rem ' + parseInt($(window).outerWidth() -  $('.container').outerWidth()) / 2 + 'px'
            );
        }
    });

    $(window).resize(function(){
        $('.menu-item.image-menu').each(function(){
            $(this).children('.sub-menu').css('left', - $(this).offset().left);
        });
    });

}
